/* FX converter system: behaviour layer.
   Server-rendered HTML works without any of this; everything here is upgrade:
   live rates via MatrixRates (rates.js), chart ranges drawn from the free ECB
   feed, a cross-check against the matrix-fx-data worker, tabs, hover, read-more.
   One file serves both the hub and the pair pages. */
(function () {
  'use strict';

  var HOST = document.querySelector('[data-fx]');
  if (!HOST) return;
  var WORKER = HOST.getAttribute('data-fx-worker') || '';
  var CODE = HOST.getAttribute('data-fx-code') || '';

  /* ── read more ─────────────────────────────────────────────── */
  [].slice.call(document.querySelectorAll('.fx .rmore')).forEach(function (b) {
    b.addEventListener('click', function () {
      var sec = b.closest('section');
      var lr = sec.querySelector('.longread');
      if (lr) lr.classList.add('open');
      var f = sec.querySelector('.lfade');
      if (f) f.style.display = 'none';
      b.style.display = 'none';
    });
  });

  /* ── order form: buy CTAs scroll down and carry the amount ─── */
  var ORDER = document.getElementById('fx-order');
  if (ORDER) {
    [].slice.call(document.querySelectorAll('[data-fx-buy]')).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var amt = document.getElementById('fx-amt');
        var tgt = document.getElementById('fxf-amt');
        if (amt && tgt && amt.value) tgt.value = amt.value;
        ORDER.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var nm = document.getElementById('fxf-name');
        if (nm) setTimeout(function () { nm.focus({ preventScroll: true }); }, 650);
      });
    });
    if (location.hash === '#fx-order' || location.hash === '#hfBuyForm' || location.hash === '#contact_form') ORDER.scrollIntoView();
    /* Amount pages link here as /pages/usd-to-inr?amt=1000#fx-order */
    var qp = null;
    try { qp = new URLSearchParams(location.search).get('amt'); } catch (e) {}
    if (qp && /^[0-9.,]+$/.test(qp)) {
      var tgt2 = document.getElementById('fxf-amt');
      var amt2 = document.getElementById('fx-amt');
      if (tgt2) tgt2.value = qp;
      if (amt2) { amt2.value = qp; try { amt2.dispatchEvent(new Event('input')); } catch (e) {} }
    }
  }

  /* Serialise the order into contact[body] before submit, mirroring the
     hero form's email format (snippets/hero-form.liquid buildBody), so
     these leads land in the same inbox looking the same. */
  var OFORM = document.getElementById('hfBuyForm');
  if (OFORM) {
    var bold = function (str) {
      return String(str).replace(/[A-Za-z0-9]/g, function (c) {
        var n = c.charCodeAt(0);
        if (n >= 65 && n <= 90) return String.fromCodePoint(0x1D5D4 + n - 65);
        if (n >= 97 && n <= 122) return String.fromCodePoint(0x1D5EE + n - 97);
        return String.fromCodePoint(0x1D7EC + n - 48);
      });
    };
    OFORM.addEventListener('submit', function () {
      var q = function (n) { var el = OFORM.querySelector('[name="contact[' + n + ']"]'); return el ? el.value : ''; };
      var svc = (OFORM.querySelector('[name="contact[service]"]:checked') || {}).value || '';
      var amtEl = document.getElementById('fxf-amt');
      var amtRaw = amtEl ? parseFloat((amtEl.value || '').replace(/[^0-9.]/g, '')) : 0;
      var qty = amtRaw ? amtRaw.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' ' + CODE : '';
      var qtyRate = qty;
      if (amtRaw && CALC_MID) {
        qtyRate += ' @ ₹' + (CALC_MID >= 1 ? CALC_MID.toFixed(2) : CALC_MID.toFixed(4));
        qtyRate += ' · ₹' + money(amtRaw * CALC_MID, true);
      }
      var phone = String(q('phone') || '').replace(/\D/g, '').slice(-10);
      var lines = [];
      lines.push([q('name'), q('city'), qtyRate, svc].filter(Boolean).join(' · '));
      lines.push('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
      lines.push('');
      lines.push(bold('CONTACT — BUY FOREX'));
      lines.push('Name    : ' + q('name'));
      lines.push('Phone   : ' + phone);
      lines.push('Email   : ' + q('email'));
      lines.push('City    : ' + q('city'));
      if (qty) lines.push('Amount  : ' + qty.replace(/,/g, ''));
      lines.push('Product : ' + svc);
      lines.push('');
      lines.push(bold('LEAD SOURCE'));
      /* Real acquisition channel (Google Organic / Google Ads / Direct / …),
         classified by mx-tracking exactly like the hero form. The old hardcoded
         'Currency page (X to INR)' label masked whether the lead was organic,
         paid or direct; that page context is preserved on the Landing page line
         below. Same tracking-object precedence as the lead-vault block. */
      var mxt = window.__hfTracking || (window.MxTracking && window.MxTracking.data) || {};
      var mxSrc = (window.MxTracking && window.MxTracking.classifySource)
        ? window.MxTracking.classifySource() : '';
      var plainLabel = function (s) {
        /* Shopify's contact-form filter discards any submission whose body carries a
           URL or a host.tld, because hosts like www.google.com appear across the whole
           platform (Shopify Specialist Support, 7 Sep 2026). Labels stay readable but
           never in domain format: "Campaign: chatgpt.com" becomes "Campaign: chatgpt com". */
        return String(s || '')
          .replace(/[a-z][a-z0-9+.\-]*:\/\/+/gi, '')
          .replace(/\b([a-z0-9\-]+)((?:\.[a-z0-9\-]+)+)\b/gi, function (m, a, b) { return a + b.replace(/\./g, ' '); })
          .replace(/\/+\s*$/, '')
          .replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
      };
      lines.push('Source       : ' + plainLabel(mxSrc || 'Direct'));
      var campId = mxt.gad_campaignid || mxt.campaign_id || mxt.cid || '';
      if (campId)           lines.push('Campaign ID  : ' + campId);
      if (mxt.utm_source)   lines.push('UTM Source   : ' + plainLabel(mxt.utm_source));
      if (mxt.utm_medium)   lines.push('UTM Medium   : ' + plainLabel(mxt.utm_medium));
      if (mxt.utm_campaign) lines.push('UTM Campaign : ' + plainLabel(mxt.utm_campaign));
      if (mxt.utm_content)  lines.push('UTM Content  : ' + plainLabel(mxt.utm_content));
      if (mxt.utm_term)     lines.push('UTM Term     : ' + plainLabel(mxt.utm_term));
      lines.push('Landing page : ' + window.location.pathname + ' (' + CODE + '→INR)');
      /* No Referrer line at all (Shopify Specialist Support, 7 Sep 2026): even
         the bare hostname is parsed as a URL by their filter and the submission
         is discarded. The vault keeps the raw referrer for our own email. */
      /* Click IDs last — needed for offline conversion import, kept in full. */
      if (mxt.gclid)  lines.push('GCLID        : ' + mxt.gclid);
      if (mxt.gbraid) lines.push('GBRAID       : ' + mxt.gbraid);
      if (mxt.wbraid) lines.push('WBRAID       : ' + mxt.wbraid);
      if (mxt.fbclid) lines.push('FBCLID       : ' + mxt.fbclid);
      var body = document.getElementById('hfBodyBuy');
      if (body) body.value = lines.join('\n');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'generate_lead', lead_phone: phone });
      /* lead vault: fire-and-forget copy, captured before captcha/email */
      try {
        /* honeypot renamed to mx_hp on 2 Sep 2026 (browsers autofilled "website");
           the old name is still read so an older fx-pair.liquid keeps working */
        var hp = OFORM.querySelector('[name="mx_hp"]') || OFORM.querySelector('[name="website"]');
        var vb = {
          form: 'currency-page', name: q('name'), phone: phone,
          email: q('email'), city: q('city'), service: svc,
          currency: CODE, amount: amtEl ? amtEl.value : '',
          rate: CALC_MID ? String(CALC_MID) : '',
          total: (amtRaw && CALC_MID) ? String(Math.round(amtRaw * CALC_MID)) : '',
          website: hp ? hp.value : '',
          page: location.pathname, source: location.search || ''
        };
        try {
          var t2 = window.__hfTracking || (window.MxTracking && window.MxTracking.data) || {};
          vb.campaign_id = t2.gad_campaignid || t2.campaign_id || t2.cid || '';
          ['utm_source','utm_medium','utm_campaign','utm_content','utm_term',
           'gclid','gbraid','wbraid','fbclid','rdt_cid','oppref'].forEach(function (k) { vb[k] = t2[k] || ''; });
          vb.src_label = (window.MxTracking && window.MxTracking.classifySource)
            ? window.MxTracking.classifySource() : '';
          vb.referrer = sessionStorage.getItem('mx_first_referrer') || document.referrer || '';
        } catch (e) {}
        /* v3 (4 Sep 2026): acknowledged delivery through the site-wide sender,
           with the old fire-and-forget kept as a fallback. */
        if (window.MxVault && typeof window.MxVault.deliver === 'function') { window.MxVault.deliver(vb); }
        else {
          var vp = JSON.stringify(vb);
          var VAULT = 'https://matrix-leads.styxified2408.workers.dev/lead';
          if (navigator.sendBeacon) navigator.sendBeacon(VAULT, vp);
          else fetch(VAULT, { method: 'POST', body: vp, keepalive: true }).catch(function () {});
        }
      } catch (e) { /* never block the real submit */ }
    });
  }

  /* ── live rate layer via MatrixRates ─────────────────────────
     Every money surface (flap, converter, ladder, budgets, order form)
     quotes the BOOKABLE selling rate: feed ask + desk margin, straight
     from rates.js. Charts and history stay market data. */
  function bookable(rec) { return rec ? (rec.buy || rec.mid || 0) : 0; }
  function money(v, indian) {
    var neg = v < 0; v = Math.abs(v);
    var s;
    if (v < 100) { s = v.toFixed(2); }
    else {
      s = Math.round(v).toString();
      if (indian) {
        var last3 = s.slice(-3), rest = s.slice(0, -3);
        if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
        s = last3;
      } else {
        s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }
    return (neg ? '-' : '') + s;
  }

  function liveUpgrade(rate) {
    /* flap board: rebuild the digits at the bookable rate. Pair flaps only
       (they carry the .u unit span); the amount-page flap shows a rupee
       TOTAL, not a rate, and must not be rebuilt here. */
    var flap = document.querySelector('.flap');
    if (flap && rate && CODE && flap.querySelector('.u')) {
      var p = (window.MatrixRates && window.MatrixRates.precision)
        ? window.MatrixRates.precision(CODE) : (rate >= 1 ? 2 : 4);
      var digits = rate.toFixed(p);
      var unit = flap.querySelector('.u');
      var html = '';
      for (var i = 0; i < digits.length; i++) {
        html += digits[i] === '.'
          ? '<span class="pt" aria-hidden="true">.</span>'
          : '<span>' + digits[i] + '</span>';
      }
      flap.innerHTML = html;
      if (unit) flap.appendChild(unit);
      flap.setAttribute('aria-label', '1 ' + CODE + ' equals ' + digits + ' Indian rupees');
    }
    if (rate) {
      /* ladder cells */
      [].slice.call(document.querySelectorAll('[data-fx-amt]')).forEach(function (td) {
        var v = parseFloat(td.getAttribute('data-fx-amt')) * rate;
        td.textContent = '₹' + money(v, true);
      });
      /* big-number cells */
      [].slice.call(document.querySelectorAll('[data-fx-big]')).forEach(function (el) {
        var v = parseFloat(el.getAttribute('data-fx-big')) * rate;
        el.textContent = '₹' + money(v, true);
      });
    }
    /* rupee-budget cells: INR amount shown in foreign units */
    [].slice.call(document.querySelectorAll('[data-fx-inr]')).forEach(function (el) {
      var ccy = el.getAttribute('data-fx-ccy');
      var m2 = rate;
      if (ccy && window.MatrixRates) {
        m2 = bookable(window.MatrixRates.get(ccy));
      }
      if (!m2) return;
      el.textContent = money(parseFloat(el.getAttribute('data-fx-inr')) / m2, true);
    });
    /* hub board and rack rates */
    [].slice.call(document.querySelectorAll('[data-fx-rate]')).forEach(function (el) {
      var c = el.getAttribute('data-fx-rate');
      var v = bookable(window.MatrixRates.get(c));
      if (v) el.textContent = '₹' + (v >= 1 ? v.toFixed(2) : v.toFixed(4));
    });
    /* rate-in-words line: regenerate the whole sentence at the live rate so it
       can never drift from the flap (12 Aug 2026). Rates under ₹1 keep their
       server-rendered wording, since paise-only phrasing reads better curated. */
    [].slice.call(document.querySelectorAll('[data-fx-words]')).forEach(function (el) {
      var c = el.getAttribute('data-fx-words');
      var v = bookable(window.MatrixRates.get(c));
      if (!v || v < 1) return;
      var whole = Math.floor(v), paise = Math.round((v - whole) * 100);
      if (paise === 100) { whole++; paise = 0; }
      var s = '₹' + v.toFixed(2) + ' is ' + words(whole) + (whole === 1 ? ' rupee' : ' rupees');
      if (paise > 0) s += ' and ' + words(paise) + ' paise';
      el.textContent = s + '.';
    });
  }
  /* small Indian-English number-to-words, integers 0 to 99,99,999 */
  function words(n) {
    var ones = ['zero','one','two','three','four','five','six','seven','eight','nine','ten',
      'eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen'];
    var tens = ['','','twenty','thirty','forty','fifty','sixty','seventy','eighty','ninety'];
    function u99(x) {
      if (x < 20) return ones[x];
      return tens[Math.floor(x / 10)] + (x % 10 ? '-' + ones[x % 10] : '');
    }
    if (n < 100) return u99(n);
    var parts = [];
    if (n >= 100000) { parts.push(u99(Math.floor(n / 100000)) + ' lakh'); n %= 100000; }
    if (n >= 1000) { parts.push(u99(Math.floor(n / 1000)) + ' thousand'); n %= 1000; }
    if (n >= 100) { parts.push(ones[Math.floor(n / 100)] + ' hundred'); n %= 100; }
    if (n > 0) parts.push(u99(n));
    return parts.join(' ');
  }

  /* Calculator. The pair page shows the result in the #fx-out input; the hub
     shows it in the #fx-outwrap span (its #fx-out is hidden). The hub always
     converts USD, a pair page converts its own code. */
  var CALC_MID = 0;
  function wireCalc(mid) {
    CALC_MID = mid;
    var amt = document.getElementById('fx-amt');
    var out = document.getElementById('fx-out');
    var wrap = document.getElementById('fx-outwrap');
    if (!amt || (!out && !wrap)) return;
    var recalc = function () {
      var a = parseFloat((amt.value || '0').replace(/[^0-9.]/g, '')) || 0;
      var s = '₹' + money(a * CALC_MID, true);
      if (wrap) wrap.textContent = s;
      if (out) out.value = s;
    };
    if (!amt.hasAttribute('data-fx-wired')) {
      amt.setAttribute('data-fx-wired', '1');
      amt.addEventListener('input', recalc);
    }
    recalc();
  }

  /* Before live rates arrive, wire the calculator off the baked server rate
     (hub: the "1 USD = ₹x" line; pair: the flap aria-label). MatrixRates
     overwrites CALC_MID when it comes up. */
  (function calcFallback() {
    var t = '';
    var small = document.querySelector('.result small');
    var flap = document.querySelector('.flap');
    if (small) t = small.textContent || '';
    else if (flap) t = flap.getAttribute('aria-label') || '';
    var m = t.match(/([0-9]+(?:\.[0-9]+)?)/);
    if (m && parseFloat(m[1]) > 0) wireCalc(parseFloat(m[1]));
  })();

  function bootRates() {
    if (!window.MatrixRates || !window.MatrixRates.onReady) return;
    window.MatrixRates.onReady(function () {
      if (CODE) {
        var rate = bookable(window.MatrixRates.get(CODE));
        if (rate) { liveUpgrade(rate); wireCalc(rate); }
      } else {
        liveUpgrade(0); /* hub: repaint [data-fx-rate] cells */
        var sel = document.getElementById('fx-from');
        var small = document.querySelector('.result small');
        var applyHub = function () {
          var c = sel ? sel.value : 'USD';
          var v = bookable(window.MatrixRates.get(c));
          if (!v) {
            /* currency not in rates.js (e.g. OMR): fall back to the baked
               board cell so the converter still answers */
            var cell = document.querySelector('[data-fx-rate="' + c + '"]');
            if (cell) v = parseFloat(cell.textContent.replace(/[^0-9.]/g, '')) || 0;
          }
          if (!v) return;
          wireCalc(v);
          if (small) small.textContent = '1 ' + c + ' = ₹'
            + (v >= 1 ? v.toFixed(2) : v.toFixed(4)) + ' · our live rate';
        };
        if (sel && !sel.hasAttribute('data-fx-wired')) {
          sel.setAttribute('data-fx-wired', '1');
          sel.addEventListener('change', applyHub);
        }
        applyHub();
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootRates);
  } else { bootRates(); }

  /* ── worker cross-check badge ──────────────────────────────── */
  if (WORKER && CODE) {
    fetch(WORKER + '/outlook/' + CODE.toLowerCase() + '.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.computed) return;
        var b = document.getElementById('fx-wbadge');
        var t = document.getElementById('fx-wbtxt');
        if (b) b.classList.add('onn');
        if (t) t.textContent = 'live data · computed ' + d.computed;
        var oc = document.getElementById('fx-olcomputed');
        if (oc) oc.textContent = d.computed;
      }).catch(function () {});
  }

  /* ── chart: ranges drawn from the ECB feed ─────────────────── */
  var chart = document.querySelector('[data-fx-chart]');
  if (!chart || !CODE) return;
  var RANGES = { '1M': 32, '3M': 95, '1Y': 370, '5Y': 1830, '10Y': 3660 };
  var cache = {};
  var ARCH = chart.hasAttribute('data-fx-archive');

  function downsample(pts) {
    var stride = Math.max(1, Math.floor(pts.length / 300));
    var out = pts.filter(function (_, i) { return i % stride === 0; });
    if (out[out.length - 1].d !== pts[pts.length - 1].d) out.push(pts[pts.length - 1]);
    return out;
  }

  /* Full snapshot series from the data worker, for currencies with no ECB feed. */
  function fetchSeries() {
    if (cache.__arch) return Promise.resolve(cache.__arch);
    return fetch(WORKER + '/history/' + CODE.toLowerCase() + '.json')
      .then(function (r) { return r.json(); })
      .then(function (rows) {
        cache.__arch = (rows || []).filter(function (p) { return p && p.d && p.v; });
        return cache.__arch;
      });
  }

  function sliceRange(all, label) {
    var cut = new Date(Date.now() - RANGES[label] * 864e5).toISOString().slice(0, 10);
    var pts = all.filter(function (p) { return p.d >= cut; });
    return downsample(pts.length ? pts : all);
  }

  /* Charts come from OUR worker (/ecb/ = nightly ECB cache incl. the pegged
     Gulf currencies, /history/ = own snapshot archive). The public ECB mirror
     is only a fallback for the transition window and worker outages. */
  function fetchRange(label) {
    if (ARCH) {
      return fetchSeries().then(function (all) { return sliceRange(all, label); });
    }
    if (cache[label]) return Promise.resolve(cache[label]);
    var own = cache.__ws ? Promise.resolve(cache.__ws)
      : (WORKER ? fetch(WORKER + '/ecb/' + CODE.toLowerCase() + '.json')
          .then(function (r) { return r.json(); })
          .then(function (rows) {
            var out = (rows || []).filter(function (p) { return p && p.d && p.v; });
            if (out.length >= 200) { cache.__ws = out; return out; }
            return null;
          }).catch(function () { return null; })
        : Promise.resolve(null));
    return own.then(function (all) {
      if (all) { cache[label] = sliceRange(all, label); return cache[label]; }
      var days = RANGES[label];
      var start = new Date(Date.now() - days * 864e5);
      var url = 'https://api.frankfurter.dev/v1/'
        + start.toISOString().slice(0, 10) + '..'
        + '?base=' + CODE + '&symbols=INR';
      return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        var dates = Object.keys(j.rates).sort();
        var pts = dates.map(function (d) { return { d: d, v: j.rates[d].INR }; });
        cache[label] = downsample(pts);
        return cache[label];
      });
    });
  }

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fdate(d, mode) {
    var y = d.slice(0, 4), m = parseInt(d.slice(5, 7), 10), dd = parseInt(d.slice(8, 10), 10);
    if (mode === 'day') return dd + ' ' + MONTHS[m - 1];
    if (mode === 'mon') return MONTHS[m - 1] + ' ' + y.slice(2);
    return y;
  }

  function draw(label, data) {
    var CW = 940, CH = 300, ML = 10, MR = 62, MT = 16, MB = 30;
    var mode = (label === '1M' || label === '3M') ? 'day' : (label === '1Y' ? 'mon' : 'yr');
    var vals = data.map(function (p) { return p.v; });
    var lo = Math.min.apply(null, vals), hi = Math.max.apply(null, vals);
    var pad = (hi - lo) * 0.08 || 0.5;
    var ylo = lo - pad, yhi = hi + pad;
    var X = function (i) { return ML + i * (CW - ML - MR) / (data.length - 1); };
    var Y = function (v) { return MT + (yhi - v) / (yhi - ylo) * (CH - MT - MB); };
    var line = '', area = '';
    data.forEach(function (p, i) {
      line += (i ? 'L' : 'M') + X(i).toFixed(1) + ' ' + Y(p.v).toFixed(1) + ' ';
    });
    area = line + 'L' + X(data.length - 1).toFixed(1) + ' ' + (CH - MB)
         + ' L' + X(0).toFixed(1) + ' ' + (CH - MB) + ' Z';
    var fmt = (yhi - ylo) < 8 ? 1 : 0;
    var grid = '';
    for (var k = 0; k < 4; k++) {
      var gv = ylo + (yhi - ylo) * (k + 0.5) / 4, gy = Y(gv);
      grid += '<line x1="' + ML + '" y1="' + gy.toFixed(1) + '" x2="' + (CW - MR)
        + '" y2="' + gy.toFixed(1) + '" class="gl"/>'
        + '<text x="' + (CW - MR + 8) + '" y="' + (gy + 3.5).toFixed(1)
        + '" class="ylab">₹' + gv.toFixed(fmt) + '</text>';
    }
    var xl = '';
    [0, Math.floor(data.length / 3), Math.floor(2 * data.length / 3), data.length - 1]
      .forEach(function (i, n) {
        var anch = n === 0 ? 'start' : (n === 3 ? 'end' : 'middle');
        xl += '<text x="' + X(i).toFixed(1) + '" y="' + (CH - 8) + '" class="xlab" text-anchor="'
          + anch + '">' + fdate(data[i].d, mode) + '</text>';
      });
    var ih = vals.indexOf(hi), il = vals.indexOf(lo), marks = '';
    [[ih, 'hi', -9], [il, 'lo', 16]].forEach(function (m) {
      var x = X(m[0]), y = Y(vals[m[0]]);
      marks += '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="3.4" class="mk '
        + m[1] + '"/>'
        + '<text x="' + Math.min(Math.max(x, 34), CW - MR - 10).toFixed(1) + '" y="'
        + (y + m[2]).toFixed(1) + '" class="mklab" text-anchor="middle">₹'
        + vals[m[0]].toFixed(2) + '</text>';
    });
    var endx = X(data.length - 1), endy = Y(vals[vals.length - 1]);
    var gid = 'fxag' + label;
    return '<svg viewBox="0 0 ' + CW + ' ' + CH + '" preserveAspectRatio="none" class="csvg">'
      + '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="0" y2="1">'
      + '<stop offset="0" stop-color="#02e375" stop-opacity=".25"/>'
      + '<stop offset="1" stop-color="#02e375" stop-opacity="0"/></linearGradient></defs>'
      + grid + '<path d="' + area + '" fill="url(#' + gid + ')"/>'
      + '<path d="' + line + '" fill="none" stroke="#00341B" stroke-width="2.1" '
      + 'stroke-linejoin="round" stroke-linecap="round"/>'
      + marks + '<circle cx="' + endx.toFixed(1) + '" cy="' + endy.toFixed(1)
      + '" r="4.6" class="end"/>' + xl + '</svg>';
  }

  function stats(label, data) {
    var vals = data.map(function (p) { return p.v; });
    var hi = Math.max.apply(null, vals), lo = Math.min.apply(null, vals);
    var avg = vals.reduce(function (a, b) { return a + b; }, 0) / vals.length;
    var chg = (vals[vals.length - 1] / vals[0] - 1) * 100;
    var mode = (label === '1M' || label === '3M') ? 'day' : (label === '1Y' ? 'mon' : 'yr');
    var dir = chg >= 0 ? 'chup' : 'chdn';
    var arr = chg >= 0 ? '▲' : '▼';
    return '<div><span>' + label + ' High</span><b>₹' + hi.toFixed(2) + '</b></div>'
      + '<div><span>' + label + ' Low</span><b>₹' + lo.toFixed(2) + '</b></div>'
      + '<div><span>Average</span><b>₹' + avg.toFixed(2) + '</b></div>'
      + '<div><span>Change Since ' + fdate(data[0].d, mode) + '</span><b class="' + dir + '">'
      + arr + ' ' + Math.abs(chg).toFixed(1) + '%</b></div>';
  }

  function hover(panel, data) {
    var cross = panel.querySelector('.cross');
    if (!cross) return;
    var xline = cross.querySelector('.xline'), tip = cross.querySelector('.tip');
    panel.onmousemove = function (e) {
      var rect = panel.getBoundingClientRect();
      var frac = (e.clientX - rect.left) / rect.width;
      var f2 = Math.max(0, Math.min(1, (frac - 0.011) / (0.935 - 0.011)));
      var i = Math.round(f2 * (data.length - 1));
      var x = (0.011 + f2 * (0.935 - 0.011)) * rect.width;
      cross.removeAttribute('hidden');
      xline.style.display = 'block'; xline.style.left = x + 'px';
      tip.style.display = 'block'; tip.style.top = '10px';
      tip.style.left = Math.max(60, Math.min(rect.width - 60, x)) + 'px';
      tip.textContent = data[i].d + '  ·  ₹' + data[i].v.toFixed(2);
    };
    panel.onmouseleave = function () {
      xline.style.display = 'none'; tip.style.display = 'none';
    };
  }

  function show(label) {
    [].slice.call(chart.querySelectorAll('.ctab')).forEach(function (t) {
      t.classList.toggle('on', t.getAttribute('data-r') === label);
    });
    [].slice.call(chart.querySelectorAll('.cpanel,.cstats')).forEach(function (p) {
      if (p.getAttribute('data-r') === label) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });
    var panel = chart.querySelector('.cpanel[data-r="' + label + '"]');
    var strip = chart.querySelector('.cstats[data-r="' + label + '"]');
    fetchRange(label).then(function (data) {
      panel.innerHTML = draw(label, data)
        + '<div class="cross" hidden><div class="xline"></div><div class="tip"></div></div>';
      if (strip) strip.innerHTML = stats(label, data);
      hover(panel, data);
    }).catch(function () { /* server-rendered content stays */ });
  }

  [].slice.call(chart.querySelectorAll('.ctab')).forEach(function (b) {
    b.addEventListener('click', function () { show(b.getAttribute('data-r')); });
  });
  /* refresh the default range live, enable hover on it */
  var def = chart.querySelector('.ctab.on');
  if (def) show(def.getAttribute('data-r'));

  /* Archive currencies: reveal the chart section once the worker's snapshot
     archive holds enough days, unlocking longer ranges as history grows. */
  if (ARCH && WORKER) {
    fetchSeries().then(function (all) {
      if (all.length < 25) return;              /* stays hidden until mid-Sep 2026 */
      var span = (new Date(all[all.length - 1].d) - new Date(all[0].d)) / 864e5 + 1;
      var first = null;
      [].slice.call(chart.querySelectorAll('.ctab')).forEach(function (t) {
        var need = RANGES[t.getAttribute('data-r')];
        if (need <= span * 1.35) { t.removeAttribute('hidden'); first = first || t; }
      });
      if (!first) return;
      var now = document.getElementById('fx-archnow');
      if (now) now.textContent = '₹' + (all[all.length - 1].v >= 1
        ? all[all.length - 1].v.toFixed(2) : all[all.length - 1].v.toFixed(4));
      var wrap = chart.closest('[data-fx-archwrap]') || chart.closest('section');
      if (wrap) wrap.removeAttribute('hidden');
      var pick = chart.querySelector('.ctab[data-r="3M"]:not([hidden])') || first;
      show(pick.getAttribute('data-r'));
    }).catch(function () { /* archive not ready */ });
  }
})();
